import React, { useState } from 'react';
import { StatusBanca, BancaUtils } from '../../../model/banca/Banca';
import { FaArrowRight, FaTimes, FaExchangeAlt } from 'react-icons/fa';
import { BsCheckCircleFill, BsCheck2Circle, BsArrowDownRight, BsHddNetwork } from 'react-icons/bs';
import AnimatedModal from './AnimatedModal';

interface StatusBancaModalProps {
  status: StatusBanca;
  onClose: () => void;
}

const StatusBancaModal: React.FC<StatusBancaModalProps> = ({ status, onClose }) => {
  const [currentStatus, setCurrentStatus] = useState<StatusBanca>(status);

  const mainFlowStatuses = [
    StatusBanca.INDEFINIDA,
    StatusBanca.PLANEJADA,
    StatusBanca.CONSULTADA,
    StatusBanca.DISPONIBILIDADE,
    StatusBanca.DEFINIDA,
    StatusBanca.CONVOCADA
  ];

  const getStatusIcon = (status: StatusBanca) => {
    switch (status) {
      case StatusBanca.INTEGRACAO: return null;
      case StatusBanca.FINALIZADA: return <BsCheckCircleFill style={{ marginRight: '4px' }} />;
      case StatusBanca.CANCELADA: return <FaTimes style={{ marginRight: '4px' }} />;
      default: return null;
    }
  };

  return (
    <AnimatedModal isOpen={true} onClose={onClose}>
      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '8px',
        width: '1200px',
        maxWidth: '95vw',
        maxHeight: '90vh',
        overflow: 'auto'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '25px',
          paddingBottom: '15px',
          borderBottom: '2px solid #007bff'
        }}>
          <h3 style={{ margin: 0, color: '#007bff' }}>Fluxo de Status das Bancas</h3>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#666'
            }}
          >
            ×
          </button>
        </div>

        {/* Fluxo Principal */}
        <div style={{ marginBottom: '30px' }}>
          <h6 style={{ textAlign: 'center', marginBottom: '15px', color: '#666' }}>Fluxo Principal</h6>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap', gap: '8px' }}>
            {mainFlowStatuses.map((statusItem, index) => (
              <React.Fragment key={statusItem}>
                <button
                  style={{
                    backgroundColor: BancaUtils.getStatusColor(statusItem),
                    color: 'black',
                    border: currentStatus === statusItem ? '3px solid #000' : '1px solid #ccc',
                    borderRadius: '3px',
                    padding: '8px 12px',
                    fontSize: '12px',
                    cursor: 'pointer',
                    minWidth: '110px',
                    fontWeight: currentStatus === statusItem ? 'bold' : 'normal'
                  }}
                  onClick={() => setCurrentStatus(statusItem)}
                >
                  {BancaUtils.getStatusBancaString(statusItem).replace('Banca ', '')}
                </button>
                {index < mainFlowStatuses.length - 1 && (
                  <FaArrowRight style={{ color: '#666', margin: '0 4px' }} />
                )}
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Fluxos Secundários */}
        <div style={{ marginBottom: '30px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '40px' }}>                                
            {/* Integração */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <BsHddNetwork style={{ color: '#666', fontSize: '14px' }} />
                  <FaExchangeAlt style={{ color: '#666', fontSize: '12px' }} />
                  <BsHddNetwork style={{ color: '#666', fontSize: '14px' }} />
                </div>
              </div>
              <button
                style={{
                  backgroundColor: '#ffffff',
                  color: 'black',
                  border: currentStatus === StatusBanca.INTEGRACAO ? '3px solid #000' : '1px solid #666',
                  borderRadius: '3px',
                  padding: '8px 12px',
                  fontSize: '12px',
                  cursor: 'pointer',
                  minWidth: '100px',
                  fontWeight: currentStatus === StatusBanca.INTEGRACAO ? 'bold' : 'normal'
                }}
                onClick={() => setCurrentStatus(StatusBanca.INTEGRACAO)}
              >

                {BancaUtils.getStatusBancaString(StatusBanca.INTEGRACAO).replace('Banca ', '')}
              </button>
            </div>

            {/* Finalizada */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <div style={{ marginBottom: '8px' }}>
                <BsCheck2Circle style={{ color: '#28a745' }} />
              </div>
              <button
                style={{
                  backgroundColor: BancaUtils.getStatusColor(StatusBanca.FINALIZADA),
                  color: 'black',
                  border: currentStatus === StatusBanca.FINALIZADA ? '3px solid #000' : '1px solid #ccc',
                  borderRadius: '3px',
                  padding: '8px 12px',
                  fontSize: '12px',
                  cursor: 'pointer',
                  minWidth: '100px',
                  fontWeight: 'bold'
                }}
                onClick={() => setCurrentStatus(StatusBanca.FINALIZADA)}
              >
                {BancaUtils.getStatusBancaString(StatusBanca.FINALIZADA).replace('Banca ', '')}
              </button>
            </div>
          </div>
        </div>

        {/* Casos de Exceção */}
        <div style={{ marginBottom: '30px' }}>
          <h6 style={{ textAlign: 'center', marginBottom: '15px', color: '#666', fontSize: '14px' }}>Casos de Exceção</h6>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '30px' }}>
            {[StatusBanca.CANCELADA, StatusBanca.FECHADA].map(statusItem => (
              <div key={statusItem} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ marginBottom: '8px' }}>
                  <BsArrowDownRight style={{ color: '#666' }} />
                </div>
                <button
                  style={{
                    backgroundColor: BancaUtils.getStatusColor(statusItem),
                    color: 'black',
                    border: currentStatus === statusItem ? '3px solid #000' : '1px solid #666',
                    borderRadius: '3px',
                    padding: '6px 10px',
                    fontSize: '11px',
                    cursor: 'pointer',
                    minWidth: '90px',
                    fontWeight: currentStatus === statusItem ? 'bold' : 'normal'
                  }}
                  onClick={() => setCurrentStatus(statusItem)}
                >
                  {getStatusIcon(statusItem)}
                  {BancaUtils.getStatusBancaString(statusItem).replace('Banca ', '')}
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Descrição do Status */}
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '20px',
          borderRadius: '5px',
          borderLeft: `4px solid ${BancaUtils.getStatusColor(currentStatus)}`,
          marginBottom: '20px'
        }}>
          <h5 style={{ textAlign: 'center', marginBottom: '15px', color: '#333' }}>
            {BancaUtils.getStatusBancaString(currentStatus)}
          </h5>
          <p style={{ margin: 0, textAlign: 'center', color: '#666', lineHeight: '1.5' }}>
            {BancaUtils.getStatusExplanation(currentStatus)}
          </p>
        </div>

        <div style={{ textAlign: 'center' }}>
          <button
            onClick={onClose}
            style={{
              padding: '10px 24px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Fechar
          </button>
        </div>
      </div>
    </AnimatedModal>
  );
};

export default StatusBancaModal;